export const SET_CURRENT_OPTIONS = 'menus/SET_CURRENT_OPTIONS_SUCCESS';
export const SET_CURRENT_OPTIONS_REQUEST = 'menus/SET_CURRENT_OPTIONS_REQUEST';
